<template>
  <div class="fob-entity-compact columns">
    <div class="column is-narrow fob-hide-in-print" style="width: 5rem">
      <b-field addon>
        <router-link class="control"
          :to="{ name: entityDetailsRoute,
                params: {
                  resourceType,
                  resourceId
                }
              }"
        >
          <b-tooltip square position="is-top" :label="$gettext('component.entity.compact.details')">
            <b-icon icon="search" type="is-aquamarine"></b-icon>
          </b-tooltip>
        </router-link>
        <template v-if="userCanEditByKostenstelle(data)">
          <template v-if="$leurisMode === 'PORTAL'">
            <a :href="portalEditLink">
            <b-tooltip square position="is-top" :label="$gettext('component.entity.compact.edit')">
              <b-icon icon="edit" type="is-aquamarine"></b-icon>
            </b-tooltip>
            </a>
          </template>
          <template v-if="$leurisMode === 'FOB'">
            <router-link class="control"
              :to="{ name: entityEditRoute,
                    params: {
                      resourceType,
                      resourceId
                    }
                  }"
            >
              <b-tooltip square position="is-top" :label="$gettext('component.entity.compact.edit')">
                <b-icon icon="edit" type="is-aquamarine"></b-icon>
              </b-tooltip>
            </router-link>
          </template>
        </template>
        <span
          v-if="showStar"
          :class="{ 'fob-menu-is-disabled': !maco.loggedIn }"
          style="cursor: pointer;"
          @click="favourResearchActivity({
            resourceType,
            resourceId
          })"
        >
          <b-tooltip
            square
            position="is-top"
            :label="isFavouredResearchActivity({resourceType,resourceId}) ?
              $gettext('component.entity.compact.favour.deselect') :
              $gettext('component.entity.compact.favour.select')"
          >
            <b-icon :icon="isFavouredResearchActivity({resourceType,resourceId}) ? 'star' : 'star-o'" type="is-aquamarine"></b-icon>
          </b-tooltip>
        </span>
      </b-field>
    </div>
    <div class="column">
      <div v-html="data.html[currentLocale]"></div>
    </div>
    <div v-if="showPublicationsCount" class="extra-info">
      <div class="tag is-aquamarine pubcount" v-if="data.publications_count > 0">
        {{data.publications_count}} {{data.publications_count > 1 ? this.$gettext("Publikationen") : this.$gettext("Publikation") }}
      </div>
      <div class="small-icon-row">
        <div v-for="(sdg, index) in data.sdg" :key="index">
          <b-tooltip :label="`SDG ${sdg._id}: ` + $gettext(`Sdg.SDG${sdg._id}`)" position="is-left">
            <router-link :to="currentPublicRoute().withQuery({ sdg: `SDG${sdg._id}` })">
              <img :src="sdgLink(sdg._id)" width="24">
            </router-link>
          </b-tooltip>
        </div>
      </div>
    </div>
    <div v-if="showPublicationType" class="fob-hide-in-print">
      <translate class="tag is-aquamarine">{{`PublikationsTyp.${data.publikationsTyp}`}}</translate>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import ExternalLinkProvider from '@/components/mixins/ExternalLinkProvider'
import UserCanEditByKostenstelle from '@/components/mixins/UserCanEditByKostenstelle'
import FavourResearchActivity from '@/components/mixins/FavourResearchActivity'
import DateTimeHelper from '@/components/mixins/DateTimeHelper'
import PublicRouteBuilder from '@/components/mixins/PublicRouteBuilder'

export default {
  name: 'fob-entity-compact-cyan',
  mixins: [
    DateTimeHelper,
    ExternalLinkProvider,
    FavourResearchActivity,
    PublicRouteBuilder,
    UserCanEditByKostenstelle,
  ],
  props: [
    'data',
    'entityDetailsRoute',
    'entityEditRoute',
    'showPublicationsCount',
    'showPublicationType',
    'showStar'
  ],
  computed: {
    ...mapGetters({
      maco: 'tomaner/maco'
    }),
    resourceType () {
      return this.data._entityName.split('.').splice(-1)[0].toLowerCase()
    },
    resourceId () {
      if (this.entityDetailsRoute === 'anzeigen_einzeln') {
        return this.data._id
      } else {
        return this.data.primaryPublicIdent || this.data._id
      }
    },
    internalId () {
      return this.data._id
    }
  },
  methods: {
    sdgLink (id) {
      let lpad = `0${id}`.slice(-2)
      return `/static/sdg/E_WEB_${lpad}.png`
    }
  }
}
</script>

<style>
  .fob-entity-compact-component {
    page-break-after: avoid;
    display: inline-block;
    vertical-align: bottom;
  }
 .fob-compact-item-title {
   font-weight: bold;
 }
 .fob-compact-item-key {
   font-style: italic;
   padding-right: 5px;
 }

 .small-icon-row {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 3px;
  width: 110px;
 }

 .extra-info {
  margin-top: 0.75rem;
  display: flex;
  gap: 5px;
  align-items: flex-end;
  justify-content: flex-start;
  flex-direction: column;
 }
</style>



// WEBPACK FOOTER //
// src/components/EntityCompactCyan.vue